import debug from 'bows';

const log = debug('playworks-near-you');

class PlayworksNearYou {
	constructor(node) {
		this.node = node;
		this.map = this.node.querySelector('.pny-map');
		this.aside = this.node.querySelector('.pny-aside');
		this.svg = this.node.querySelector('.pny-svg');
		this.states = Array.prototype.slice.call(this.svg.querySelectorAll('g[data-state]'));
		this.dict = {};
		this.active = null;
		this.activeClass = 'active';

		this.select = document.createElement('select');
		this.select.className = 'pny-map__state-select';
		this.states.forEach((state) => {
			let opt = document.createElement('option');
			opt.value = state.getAttribute('data-state');
			opt.appendChild(document.createTextNode(state.getAttribute('data-name')));
			this.select.appendChild(opt);
		});
		this.aside.appendChild(this.select);
		this.select.insertAdjacentHTML('beforebegin', '<p class="pny-map__state-select-label">Select a state</p>');
		this.select.addEventListener('change', (e) => {
			this.activate(e.target.value);
		});

		this.selectContent = document.createElement('div');
		this.selectContent.className = 'pny-map__state-select-content';
		this.aside.appendChild(this.selectContent);

		this.resize();
		window.addEventListener('site.resize', this.resize.bind(this));

		this.states.forEach((node) => {
			const state = node.getAttribute('data-state');
			this.dict[state] = {
				node: node,
				content: this.node.querySelector(`.pny-map__state[data-state="${state}"]`),
				tri: this.node.querySelector(`.pny-map__state[data-state="${state}"] .pny-map__state-tri`)
			}
			node.addEventListener('click', () => {
				this.activate(state);
			});
			this.dict[state].content.addEventListener('click', () => {
				this.deactivate();
			});
		});
	}

	resize() {
		this.svg.style.width = `${this.map.offsetWidth}px`;
		this.svg.style.height = `${Math.ceil(this.map.offsetWidth * .618)}px`;

		if (this.active) {
			this.position(this.active);
		}
	}

	position(state) {
		const node = this.dict[state].node;
		const content = this.dict[state].content;
		const nodeRect = node.getBoundingClientRect();
		const contentRect = content.getBoundingClientRect();
		const mapRect = this.map.getBoundingClientRect();
		const adjustX = parseInt(node.getAttribute('data-adjust-x'), 10);
		const adjustY = parseInt(node.getAttribute('data-adjust-y'), 10);

		let left = nodeRect.left - mapRect.left - (contentRect.width / 2) + (nodeRect.width / 2) + adjustX;
		let top = nodeRect.top - mapRect.top - contentRect.height + adjustY;
		let triOffset = 0;

		if (left < 10) {
			triOffset = Math.round(10 + Math.abs(left)) * -1;
			left = 10;
		} else if (left + content.offsetWidth > document.body.clientWidth) {
			triOffset = left - (document.body.clientWidth - 10 - content.offsetWidth);
			left = document.body.clientWidth - 10 - content.offsetWidth;
		}

		content.style.left = `${left}px`;
		content.style.top = `${top}px`;
		if (triOffset !== 0) {
			this.dict[state].tri.style.transform = `translateX(${triOffset}px)`;
		}
	}

	activate(state) {
		if (this.dict[state]) {
			if (this.active) {
				this.deactivate();
			}

			this.position(state);

			this.select.value = state;
			this.selectContent.innerHTML = this.dict[state].content.innerHTML;

			this.dict[state].node.setAttribute('class', this.activeClass);
			this.dict[state].content.classList.add(this.activeClass);

			// this.select.value = state;
			this.active = state;
		}
	}

	deactivate() {
		if (this.active) {
			this.dict[this.active].node.removeAttribute('class');
			this.dict[this.active].content.classList.remove(this.activeClass);
			this.active = null;
			this.selectContent.innerHTML = '';
		}
	}
}

export default PlayworksNearYou;
